import React from 'react';

import CircleCancelMajor from 'src/assets/images/common/CircleCancelMajor.svg';

type Props = {
  title: string,
  embeddedURL: string,
  active: Boolean,
  height?: Number,
  onClose: () => void
};

const YoutubeModal: React.FC<Props> = ({ embeddedURL, title, active, height, onClose }) => {
  if (!active) return null;

  const videoUrl =
    embeddedURL.indexOf('?') > 0
      ? `${embeddedURL}&autoplay=1&&mute=1`
      : `${embeddedURL}?autoplay=1&&mute=1`;

  return (
    <div id="youtubeModal-Backdrop">
      <div id="youtubeModal-Content">
        <button id="youtubeModal-Button" onClick={onClose}>
          {/* TODO: V6 Upgrade, replace with Polaris Icon  */}
          <img src={CircleCancelMajor} alt="Close button" />
        </button>

        <iframe
          width="768"
          height={height ? `${height}` : '432'}
          src={videoUrl}
          title={title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default YoutubeModal;
